import React from 'react';
import { TrueIcon, FalseIcon } from '../Icons';

const renderCellValue = (value) => {
  if (typeof value === 'boolean') {
    return <div className="flex justify-center">{value ? <TrueIcon /> : <FalseIcon />}</div>;
  }
  return value;
};

/**
 * NormalRow Component
 *
 * This component renders a standard table row with dynamic columns.
 * It receives a 'data' object containing a 'columns' array, where each column
 * includes an 'id' (used as a unique key) and a 'value' (content to display).
 *
 * Props:
 * - data: { columns: Array<{ id: string | number, value: string | JSX.Element }> }
 */
const NormalRow = ({ data }) => {
  const columns = data.columns.filter((col) => col.id !== 'idEvent');

  return (
    <tr data-testid="normal-row" className="bg-white border-b-2 whitespace-nowrap">
      {columns.map((column, index) => (
        <td
          key={column.id}
          className={`py-4 px-4 text-center text-black ${index === 0 ? 'pl-[50px]' : ''}`}
        >
          {renderCellValue(column.value)}
        </td>
      ))}
    </tr>
  );
};

export default NormalRow;
